module.exports = __webpack_public_path__ + "/images/cover-portada.2ac2ba9.jpg";